<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">Drop-Off 包裹超时罚款</h1>
                    <p class="text-white pb-3 px-3">Drop-Off 包裹超时罚款描述</p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-3 m-1">
                                    <select class="form-control" v-model="dropOffPlatform">
                                        <option value="" disabled selected>请选择结算平台</option>
                                        <option value="FLASH">FLASH</option>
                                        <option value="LAZADA">LAZADA</option>
                                    </select>
                                </div>
                                <div class="col-lg-3 m-1">
                                    <date-range-picker
                                        class="w-100"
                                        :opens="'center'"
                                        :min-date="minDate"
                                        :max-date="maxDate"
                                        :singleDatePicker="false"
                                        :appendToBody="true"
                                        :ranges="false"
                                        :closeOnEsc="false"
                                        :autoApply="true"
                                        :locale-data="{ format: 'dd-mm-yyyy' }"
                                        v-model="search">
                                    </date-range-picker>
                                </div>
                                <div class="col-lg-2 m-1">
                                    <button class="btn btn-info btn-sm-res"
                                            @click="queryFineBillList(1)">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="mt-3">
                                <b-table
                                    ref="reportDelivery"
                                    show-empty
                                    responsive
                                    :items="dataList"
                                    :fields="fields"
                                    :per-page="pageSize"
                                    :busy="busy"
                                    selectable
                                    select-mode="multi"
                                    class="scroll-bar-pop text-center"
                                    empty-text="暂无数据"
                                    empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                >
                                    <template slot="settlementStatus" slot-scope="{item}">
                                        <b-badge :variant="item.settlementStatus == 2 ? 'status-parcel-success' : 'status-parcel-danger'">{{ item.settlementStatus == 2 ? '已结算' : '未结算' }} </b-badge>
                                    </template>

                                    <template slot="action" slot-scope="{item}">
                                        <b-button size="sm" variant="info" @click="openDetail(item)">
                                            <i class="fa fa-eye"></i>
                                        </b-button>

                                        <b-button size="sm" variant="info" @click="fnPayByQrcode(item)" v-if="item.settlementStatus !== 2">
                                            支付
                                        </b-button>
                                    </template>
                                </b-table>
                                <div class="mt-3">
                                    <b-pagination
                                        :total-rows="totalItem"
                                        :current-page="pageIndex"
                                        :per-page="pageSize"
                                        :value="pageIndex"
                                        @input="changePage"
                                        align="right">
                                    </b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <drop-off-timeout-detail :options="detailOptions" v-if="detailOptions.visible"></drop-off-timeout-detail>

        <b-modal
            centered
            hide-footer
            v-model="payQrOptions.visible"
            size="md"
            hide-header
        >
            <div class="row">
                <div class="col-12">
                    <span class="close cursor-pointer" @click="closeModal()">&times;</span>
                </div>
            </div>
            <div class="row text-center">
                <div class="col-lg-12 py-4">
                    <h3>您确定要执行扣款吗？</h3>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-4">
                <b-button
                    class="px-5"
                    variant="secondary"
                    @click="closeModal()"
                >
                    ยกเลิก
                </b-button>
                <b-button
                    class="px-5"
                    variant="primary"
                    @click="fnPay()"
                >
                    ยืนยัน
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import moment from "moment";
import {payFineBill, queryFineBillList} from "@/api/dropOff";
import dropOffTimeoutDetail from "@/views/newPages/DropOff/dropOffTimeoutDetail.vue";

export default {
    name: "",
    components: {
        dropOffTimeoutDetail
    },
    data() {
        return {
            pageIndex: 1,
            pageSize: 10,
            totalItem: 0,
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            busy: false,
            dropOffPlatform: "",
            search: {
                startDate: "",
                endDate: "",
            },
            dataList: [],
            fields: [
                {
                    key: 'createTime',
                    label: '日期',
                    sortable: true
                },
                {
                    key: 'id',
                    label: 'ID',
                    sortable: true
                },
                {
                    key: 'dropOffPlatform',
                    label: '结算平台',
                    sortable: true
                },
                {
                    key: 'settlementStatus',
                    label: '结算状态',
                    sortable: true
                },
                {
                    key: 'settlementCounts',
                    label: '单量',
                    sortable: true
                },
                {
                    key: 'amount',
                    label: '罚款总和',
                    sortable: true
                },
                {
                    key: 'planExecuteTime',
                    label: '计划扣费时间',
                    sortable: true
                },
                {
                    key: 'reallyTime',
                    label: '实际扣费时间',
                    sortable: true
                },
                {
                    key: 'action',
                    label: '操作',
                    sortable: true
                },
            ],
            detailOptions: {
                visible: false,
                id: "",
                billDate: "",
                width: '1200px'
            },
            payQrOptions: {
                visible: false,
                data: {},
            }
        }
    },
    created() {

    },
    mounted() {
        this.queryFineBillList()
    },
    methods: {
        // 余额扣费
        fnPay(){
            payFineBill({
                id: this.payQrOptions.data.id
            })
                .then((res) => {
                    this.$bvModal.msgBoxOk('操作成功', {
                        title: "SUCCESS",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        okTitle: "ตกลง",
                        contentClass: "modal-success",
                        headerClass: "p-2 border-bottom-0",
                        footerClass: "p-2 border-top-0",
                        centered: true
                    });
                    this.closeModal()
                    this.queryFineBillList(1)
                })
        },
        closeModal() {
            this.payQrOptions.visible = false
        },
        fnPayByQrcode(row) {
            this.payQrOptions.data = row
            this.payQrOptions.visible = true
        },
        openDetail(row) {
            this.detailOptions.visible = true
            this.detailOptions.id = row.id
            this.detailOptions.billDate = row.billDate
        },
        changePage(i) {
            if (this.pageIndex == i) return;
            this.pageIndex = i
            this.queryFineBillList()
        },
        queryFineBillList(val) {
            if (val) {
                this.pageIndex = 1
            }
            queryFineBillList({
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                dropOffPlatform: this.dropOffPlatform,
                startDate: this.search.startDate ? moment(this.search.startDate).format("YYYY-MM-DD") + ' 00:00:00': "",
                endDate: this.search.endDate ? moment(this.search.endDate).format("YYYY-MM-DD") + "23:59:59": "",
            }).then(res => {
                console.log(res, 'queryFineBillList')
                this.dataList = res.data.records
                this.totalItem = res.data.total
            })
        }
    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>
